module.exports = __webpack_public_path__ + "img/capa-hover-video.32000afb.png";